import { useState } from "react";
import { toast } from "sonner";
import { Check, ChevronDown, RotateCcw } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { fmtShort, fmtDate } from "../lib/fmt";
import { Section } from "./Common";

function BlockerCard({ b, canResolve, onChanged }) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const resolve = async () => {
    try {
      await api.post(`/blockers/${b.id}/resolve`, { note });
      toast.success("Blocker ditandai selesai");
      onChanged();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div data-testid={`blocker-card-${b.id}`} className="card flex flex-col gap-3 p-4">
      <div className="flex items-start justify-between gap-3">
        <span data-testid={`blocker-age-${b.id}`} className={`rounded-full px-2.5 py-1 text-xs font-extrabold ${b.age >= 3 ? "bg-brand text-white" : "bg-brand-tint text-brand-deep"}`}>
          {b.age} hari
        </span>
        <span className="text-xs text-[#7a6667]">sejak {fmtShort(b.openedDate)}</span>
      </div>
      <p className="text-[15px] font-semibold leading-snug">{b.text}</p>
      <div className="text-xs text-[#7a6667]">{b.memberName} · {b.role}</div>
      {canResolve && !open && (
        <button data-testid={`blocker-resolve-open-${b.id}`} onClick={() => setOpen(true)} className="btn-soft self-start"><Check size={15} /> Selesai</button>
      )}
      {open && (
        <div className="flex flex-col gap-2">
          <input data-testid={`blocker-note-input-${b.id}`} className="field" placeholder="Catatan (opsional)" value={note} onChange={(e) => setNote(e.target.value)} />
          <div className="flex gap-2">
            <button data-testid={`blocker-resolve-confirm-${b.id}`} onClick={resolve} className="btn-primary flex-1">Tandai selesai</button>
            <button onClick={() => setOpen(false)} className="btn-ghost">Batal</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default function BlockerSection({ data, reload }) {
  const [showDone, setShowDone] = useState(false);
  const meId = data.me?.id;
  const priv = data.privileged;
  const reopen = async (id) => {
    try {
      await api.post(`/blockers/${id}/reopen`);
      toast.success("Blocker dibuka lagi");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Section id="blockers" eyebrow="Blocker Terbuka" title={`${data.blockersOpen.length} blocker menunggu`}>
      {data.blockersOpen.length === 0 ? (
        <div data-testid="blockers-empty" className="card bg-brand-soft p-5 text-sm font-semibold">Tidak ada blocker terbuka. Semua lancar.</div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {data.blockersOpen.map((b) => (
            <BlockerCard key={b.id} b={b} canResolve={priv || b.memberId === meId} onChanged={reload} />
          ))}
        </div>
      )}
      <button data-testid="blockers-done-toggle" onClick={() => setShowDone(!showDone)} className="mt-4 inline-flex min-h-[44px] items-center gap-1.5 text-sm font-bold text-brand-deep">
        <ChevronDown size={16} className={`transition-transform ${showDone ? "rotate-180" : ""}`} /> Blocker selesai 14 hari terakhir ({data.blockersDone.length})
      </button>
      {showDone && (
        <div className="mt-2 divide-y divide-brand-line rounded-2xl border border-brand-line" data-testid="blockers-done-list">
          {data.blockersDone.length === 0 && <p className="p-4 text-sm text-[#7a6667]">Belum ada.</p>}
          {data.blockersDone.map((b) => (
            <div key={b.id} className="flex flex-wrap items-center justify-between gap-3 p-4">
              <div className="min-w-0">
                <p className="text-sm font-semibold line-through decoration-brand/40">{b.text}</p>
                <p className="text-xs text-[#7a6667]">{b.memberName} · selesai {fmtDate(b.resolvedAt.slice(0, 10))} oleh {b.resolvedBy}{b.note ? ` · "${b.note}"` : ""}</p>
              </div>
              {priv && (
                <button data-testid={`blocker-reopen-${b.id}`} onClick={() => reopen(b.id)} className="btn-ghost"><RotateCcw size={14} /> Buka lagi</button>
              )}
            </div>
          ))}
        </div>
      )}
    </Section>
  );
}
